import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import {Link} from 'react-router-dom';
import SupporterDetailsBlockContainer from '../../containers/blocks/supporter/SupporterDetailsBlockContainer';
import SupporterEmergencyContactBlockContainer from '../../containers/blocks/supporter/SupporterEmergencyContactBlockContainer';
import SupporterProjectBlockContainer from '../../containers/blocks/supporter/SupporterProjectBlockContainer';
import SupporterActionsBlockContainer from '../../containers/blocks/supporter/SupporterActionsBlockContainer';
import SupporterCommentsBlockContainer from '../../containers/blocks/supporter/SupporterCommentsBlockContainer';
import SupporterShiftsBlockContainer from '../../containers/blocks/supporter/SupporterShiftsBlockContainer';
import PageHeader from '../elements/PageHeader';
import SupporterEventsBlock from '../blocks/supporter/SupporterEventsBlock';
import TicketToasterProvisions from "../../app/supporter/blocks/TicketToasterProvisions";
import Ticket from "../../app/supporter/blocks/Ticket";
import NameHelper from '../../helpers/nameHelper';

class SupporterScreen extends Component {

    nextSupporterId = () => {
        const {supporters} = this.props;
        let visibleSupporters = supporters.filter(el => el.visible);
        if (!visibleSupporters || visibleSupporters.length === 0) return null;
        let curIndex = visibleSupporters.findIndex(el => el.id === parseInt(this.props.match.params.id));
        if (curIndex !== undefined && curIndex < (visibleSupporters.length - 1)) {
            return visibleSupporters[curIndex + 1].id;
        } else {
            return visibleSupporters[0].id;
        }
    }

    render() {
        const {t, supporterDetails, supporterProject} = this.props;
        let nextSupporterId = this.nextSupporterId();
        const externalCrew = supporterProject && supporterProject.sojusProjectCrew ? supporterProject.sojusProjectCrew : null;
        return (
            <div>
                <PageHeader title={t('supporterScreen.title', {name: NameHelper.displayName(supporterDetails)})} subtitle={(
                    <span>
                        <Link to="/supporter">
                            {t('supporterScreen.backToOverview')}
                        </Link>
                        {nextSupporterId && (
                            <Fragment>
                                &nbsp;|&nbsp;
                                <Link to={`/supporter/${this.nextSupporterId()}`}>
                                    Nächste:r Supporter:in
                                </Link>
                            </Fragment>
                        )}
                    </span>
                )} availableAsSteward={supporterDetails.availableAsSteward} availableForBottleDeposit={supporterDetails.availableForBottleDeposit} stewardFormReceived={supporterDetails.stewardFormReceived}/>
                {externalCrew && (
                    <div className="row m-t">
                        <div className="col-xs-12">
                            <div className="alert text-center" style={{fontSize: '20px', fontWeight: 'bold', background: '#8fdc8f', borderColor: '#5cb85c', color: '#155724'}}>
                                {t('supporterScreen.externalCrew.banner')} {externalCrew}
                            </div>
                        </div>
                    </div>
                )}
                <div className="row m-t">
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-lg-6">
                                <SupporterProjectBlockContainer supporterId={this.props.match.params.id} readOnly={!!externalCrew}/>
                            </div>
                            <div className="col-lg-6">
                                {!externalCrew && (
                                    <SupporterShiftsBlockContainer supporterId={this.props.match.params.id}/>
                                )}
                                <TicketToasterProvisions supporterId={this.props.match.params.id}/>
                                <Ticket supporterId={this.props.match.params.id} readOnly={!!externalCrew}/>
                            </div>
                        </div>
                        <SupporterEventsBlock supporterId={this.props.match.params.id}/>
                    </div>
                    <div className="col-lg-4">
                        <SupporterCommentsBlockContainer supporterId={this.props.match.params.id}/>
                        <SupporterDetailsBlockContainer supporterId={this.props.match.params.id}/>
                        <SupporterEmergencyContactBlockContainer supporterId={this.props.match.params.id}/>
                        <SupporterActionsBlockContainer externalCrew={!!externalCrew}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(SupporterScreen);
